module.exports = __webpack_public_path__ + "assets/img/block-right-c3a61f64.png";